// Lib
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API, SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { BOOT_MACHINE_STATUS, RENTAL_REQUEST_TYPE } from "@/constant/rental";
import { PERIOD, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";
import FixedRentalSettings from "@/views/component/FixedRental/FixedRentalSettings";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

// Components  
import FixedRentalExpired from "@/views/component/RentalService/Notification/FixedRentalExpired";
import FixedRentalTooEarly from "@/views/component/RentalService/Notification/FixedRentalTooEarly";
import NoDeposit from "@/views/component/RentalService/Notification/NoDeposit";
import MacUsed from "@/views/component/RentalService/Notification/MacUsed";
import MachineNotReadyStart from "@/views/component/FixedRental/Notification/MachineNotReadyStart";

export default {

    extends: baseRentalService,

    components: {
        FixedRentalSettings,
        FixedRentalExpired,
        FixedRentalTooEarly,
        MachineNotReadyStart,
        NoDeposit,
        MacUsed,
    },

    data() {

        return {
            imgDict: {
                1: "dot-green",
                2: "dot-blue",
                3: "dot-orange",
                4: "dot-red",
            },
            colorDict: {
                1: "#4CAF50",
                2: "#2196F3",
                3: "#E65100",
                4: "#F44336",
            },
            bootMachineStatus: BOOT_MACHINE_STATUS,
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            dataNote: [
                {
                    label: 'Three must-know notes before start rendering',
                    children: [
                        {
                            label: '• Z: drive is network drive used for files transferring only, so after connecting to the remote server, you need to copy files from Z: drive to C: drive and install software.'
                        },
                        {
                            label: '• DO NOT forget to DEACTIVATE your software license before shutdown the server.'
                        }
                    ]
                },
            ],

            request: {
                campaignName: null,
                period: PERIOD.THREE_HOUR,
                periodUnit: 1,
                totalCost: 0,
                continueRunning: false,
            },
            conti: false,

            packageRequiredFixedRental: ["24", "25", "30"],
        };
    },

    computed: {
        ...mapState({
            serverReport: (state) => state.common.serverReport,
        }),
        getColorKey() {
            if (this.targetImage) {
                try {
                    return this.targetImage.operatingSystem === 1
                        ? this.serverReport
                            .find((x) => x.packageId === this.targetImage.packageId)
                            .statusWindows.toString()
                        : this.serverReport
                            .find((x) => x.packageId === this.targetImage.packageId)
                            .statusUbuntu.toString();
                }
                catch {
                    return "4";
                }
            }
            else {
                return "4";
            }
        },
        getStatusText() {
            if (this.targetImage) {
                try {
                    return this.targetImage.operatingSystem === 1
                        ? this.serverReport.find(
                            (x) => x.packageId === this.targetImage.packageId
                        ).statusTextWindows
                        : this.serverReport.find(
                            (x) => x.packageId === this.targetImage.packageId
                        ).statusTextUbuntu;
                }
                catch {
                    return "full";
                }
            }
            else {
                return "full";
            }
        }
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },
    watch: {
        targetImage() {
            if(this.targetImage !== null && this.targetImage.packageId !== undefined && this.targetImage.fixedRental !== undefined)
            {
                if (this.packageRequiredFixedRental.includes(this.targetImage.packageId) && !this.targetImage.fixedRental) {
                    this.conti = true;
                }
            }
        }
    },
    mounted() {
        if(this.targetImage !== null && this.targetImage.packageId !== undefined && this.targetImage.fixedRental !== undefined)
        {
            if (this.packageRequiredFixedRental.includes(this.targetImage.packageId) && !this.targetImage.fixedRental) {
                this.conti = true;
            }
        }
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.BOOT_MACHINE);
        },
        //#endregion

        //#region Boot machine  
        boot() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);

            if (this.conti) {
                setTimeout(() => {
                    let data = {
                        campaignName: this.request.campaignName,
                        listMachineId: [this.targetImage.id],
                        // fixedRental: this.targetImage.fixedRental,
                        period: this.request.period,
                        periodUnit: this.request.periodUnit,
                        continueRunning: this.request.continueRunning,
                        deviceInformation: JSON.stringify(this.getInformationClient())
                    }
                    api.baseRequest(SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_CREATE, data)
                        .then((res) => {
                            switch (res.errorCode) {
                                case FIXED_RENTAL_STATUS.SUCCESS:
                                    EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                    EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                    this.notificationSuccess('Rental Plan success !', 'Machine has been successfully fixed rent');
                                    this.boot1();
                                    break;
                                case FIXED_RENTAL_STATUS.MACHINE_NOT_READY:
                                case FIXED_RENTAL_STATUS.BALANCE_NOT_ENOUGH:
                                case FIXED_RENTAL_STATUS.MACHINE_NOT_AVAILABLE:
                                    setTimeout(() => {
                                        this.isShowErrorInformation = true;
                                    }, 500);
                                    this.errorCode = res.errorCode
                                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                                    break;
                            }
                        })
                        .catch(error => {
                            this.processCatchApiRequest(error, "Rental Plan failed ...")
                        });
                }, this.smoothTimeOut);
            } else {
                this.boot1();
            }
        },
        //#endregion

        boot1() {
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.BOOT_MACHINE, data)
                    .then((res) => {
                        switch (res.errorCode) {
                            case BOOT_MACHINE_STATUS.SUCCESS:
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess('Booting... !', `Machine <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> is booting...</span>`);
                                break;
                            case BOOT_MACHINE_STATUS.FIXED_RENTAL_TOO_EARLY:
                            case BOOT_MACHINE_STATUS.FIXED_RENTAL_EXPIRED:
                            case BOOT_MACHINE_STATUS.BALANCE_NOT_ENOUGH:
                            case BOOT_MACHINE_STATUS.TOTAL_RECHARGE_NOT_ENOUGH:
                            case BOOT_MACHINE_STATUS.MACHINE_NOT_AVAILABLE:
                            case BOOT_MACHINE_STATUS.MAC_USED:
                                setTimeout(() => {
                                    this.isShowErrorInformation = true;
                                }, 500);
                                this.errorCode = res.errorCode
                                break;
                        }
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Boot failed ...")
                    });
            }, 1000);
        },

        //#region Rental request create
        rentalRequestCreate() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: RENTAL_REQUEST_TYPE.NOTIFY_MACHINE_AVAILABLE,
                    packageId: this.targetImage.packageId,
                    operatingSystem: this.targetImage.operatingSystem,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.baseRentalRequestCreate(
                    data,
                    this.targetImage,
                    () => { this.closeThisPopup() }
                )
            }, 1000);
        },
        //#endregion
    },
}